type Observer<T> = (data: T) => void

export class ObserverSubject<T> {
  private observers: Set<Observer<T>> = new Set()
  private state: T | null = null

  subscribe(observer: Observer<T>): () => void {
    this.observers.add(observer)
    return () => this.observers.delete(observer) // Unsubscribe function
  }

  notify(data: T) {
    this.state = data
    this.observers.forEach((observer) => observer(data))
  }

  getState(): T | null {
    return this.state
  }
}
